export const justifyContentType = {
  CENTER: 'center',
  END: 'end',
  BETWEEN: 'between',
  AROUND: 'around',
  START: 'start',
};

export const mapJustifyContentTypeToClassName = {
  [justifyContentType.CENTER]: 'flex-justify-center',
  [justifyContentType.END]: 'flex-justify-end',
  [justifyContentType.BETWEEN]: 'flex-justify-between',
  [justifyContentType.AROUND]: 'flex-justify-around',
  [justifyContentType.START]: 'flex-justify-start',
};

export const mapAlignContentTypeToClassName = {
  [justifyContentType.CENTER]: 'flex-align-center',
  [justifyContentType.END]: 'flex-align-end',
  [justifyContentType.BETWEEN]: 'flex-align-between',
  [justifyContentType.AROUND]: 'flex-align-around',
  [justifyContentType.START]: 'flex-align-start',
};

export const flexDirectionType = {
  ROW: 'row',
  COLUMN: 'column',
  ROW_REVERSE: 'row-reverse',
  COLUMN_REVERSE: 'column-reverse',
};

export const mapflexDirectionTypeToClassName = {
  [flexDirectionType.ROW]: 'flex-row',
  [flexDirectionType.COLUMN]: 'flex-column',
  [flexDirectionType.ROW_REVERSE]: 'flex-row-reverse',
  [flexDirectionType.COLUMN_REVERSE]: 'flex-column-reverse',
};
